// Sentry initialization should be imported first!
import './instrument';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

import 'moment/locale/fr';
import 'moment/locale/it';

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
